import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Customers from "../components/Customers"

const Page = props => {
  const StaticPage = props.data.wordpressPage
  const {pathname} = props.location

  let content =(
    <>
      <h1>{StaticPage.title}</h1>
      <div dangerouslySetInnerHTML={ {__html: StaticPage.content}} />
      <br/>
      <Customers/>
    </>
  )

  return (
    <>
      <Layout pathname={pathname}>
        <SEO title="Home" />
          {content}
      </Layout>
    </>
  )
}

export default Page

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPage(id: { eq: $id }) {
      title
      content
      excerpt
      slug
    }
    site {
      id
      siteMetadata {
        title
        description
      }
    }

  }
`

